import React from 'react';
import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, ResponsiveContainer, Tooltip } from 'recharts';

const RadarCompetenciasChart = ({ radarData }) => {
  const data = radarData.map(item => ({
    competencia: item.competencia,
    value: parseFloat(item.media_pontuacao.toFixed(2))
  }));

  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <h3 className="text-lg font-semibold mb-4">Radar de Competências da Equipe</h3>
      <ResponsiveContainer width="100%" height={300}>
        <RadarChart data={data}>
          <PolarGrid />
          <PolarAngleAxis dataKey="competencia" />
          <PolarRadiusAxis domain={[0, 5]} />
          <Radar name="Competências" dataKey="value" stroke="#8884d8" fill="#8884d8" fillOpacity={0.3} />
          <Tooltip />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RadarCompetenciasChart;